// extracted by mini-css-extract-plugin
export default {"container":"BlogPage_container__C94P1","card":"BlogPage_card__OkH3I","img":"BlogPage_img__E8M6-"};